import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useSyncExternalStore } from 'react';
import { Outlet, useMatches } from 'react-router-dom';
export const SITE_NAME = 'Right Hand DMS';
export function formatTitle(title, full = false) {
    if (!title) return SITE_NAME;
    return full ? title : `${title} · ${SITE_NAME}`;
}
// A detail page's own name ("1999 Nissan Stagea") beats its route's generic one ("Car").
let pageTitle = null;
const listeners = new Set();
const subscribe = (l)=>{
    listeners.add(l);
    return ()=>listeners.delete(l);
};
const getPageTitle = ()=>pageTitle;
const serverPageTitle = ()=>null;
function setPageTitle(next) {
    if (pageTitle === next) return;
    pageTitle = next;
    for (const l of listeners)l();
}
/**
 * Names the tab after what the page shows, once it's loaded. Pass undefined while loading and
 * the route's title shows until then. Call it before any early return, like any hook.
 */ export function usePageTitle(title) {
    const t = title?.trim() || null;
    useEffect(()=>{
        setPageTitle(t);
        return ()=>setPageTitle(null);
    }, [
        t
    ]);
}
function routeTitle(matches) {
    for(let i = matches.length - 1; i >= 0; i--){
        const handle = matches[i].handle;
        if (handle?.title) return {
            title: handle.title,
            full: handle.full
        };
    }
    return undefined;
}
/** Root route element: keeps document.title in step with the route and the page. */ export function RouteTitle() {
    const matches = useMatches();
    const override = useSyncExternalStore(subscribe, getPageTitle, serverPageTitle);
    const fromRoute = routeTitle(matches);
    const title = override ? formatTitle(override) : formatTitle(fromRoute?.title, fromRoute?.full);
    useEffect(()=>{
        document.title = title;
    }, [
        title
    ]);
    return /*#__PURE__*/ _jsx(Outlet, {});
}
